// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

import {ToastContainer, toast} from 'react-toastify'

import {resumeSession} from '../../actions/user'
import {startApp, getBuildId, setUpdateMessageAsShown} from '../../actions/app'

import {renderRoutes} from '../navigation'

import LoginPage from '../LoginPage'
import SpinnerPortal from '../Spinner/SpinnerPortal'
import AreYouTherePortal from '../AreYouThere/AreYouTherePortal'
import UpdateAvailableToast from '../UpdateAvailableToast'
import CloseIcon from '@material-ui/icons/Close'
// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.css'

// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import '../../styles/fonts/Font-Awesome-Pro/css/fontawesome.css'
import '../../styles/fonts/Font-Awesome-Pro/css/fa-light.css'
import 'react-toastify/dist/ReactToastify.css'

import './app.css'


toast.configure()

class App extends Component {
  componentDidMount () {
    this.props.resumeSession()
    this.props.startApp()
    this.props.getBuildId()
  }

  renderRoutes () {
    return renderRoutes()
  }

  render () {
    const {session} = this.props

    if (!session.token) {
      return (
        <>
          <SpinnerPortal/>
          <LoginPage />
        </>
      )
    }

    const {update} = this.props

    if (update.updateAvailable && !update.messageShown) {
      toast(<UpdateAvailableToast/>, {
        containerId: 'bottom-left',
        position: 'bottom-right',
        autoClose: 10000,
        onClose: this.props.declineUpdate,
        pauseOnFocusLoss: true,
        className: 'update-toast',
        bodyClassName: 'update-toast-body',
        progressClassName: 'update-toast-progress-bar',
        closeButton: <CloseIcon/>
      })
      this.props.setUpdateMessageAsShown()
    }

    return (
      <div className='app' id='app'>
        {this.renderRoutes()}
        <AreYouTherePortal/>
        <SpinnerPortal/>
        <ToastContainer enableMultiContainer containerId={'bottom-left'} position={toast.POSITION.BOTTOM_LEFT} />
        <ToastContainer enableMultiContainer containerId={'top-center'} position={toast.POSITION.TOP_CENTER} />
      </div>
    )
  }
}

function mapStateToProps ({session, buildId, update}) {
  return {session, buildId, update}
}

export default withRouter(connect(mapStateToProps, {resumeSession, startApp, getBuildId, setUpdateMessageAsShown})(App))
